<template>
    <div>
        <ul>
            <li class="form-label">{{ $t('PERCENTAGE_SPLIT') }}</li>
            <li>
                <cic-select
                    id="route_script"
                    :enabled="editing"
                    :options="profiles.map((x) => ({ value: x.scriptId, label: x.name }))"
                    :placeholder="$t('Please select...')"
                    :value="route.scriptId"
                    @input="(val) => $emit('change', 'scriptId', val)"
                />
            </li>
        </ul>
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';

    export default {
        name: 'PercentageSplit',
        components: {
            CicSelect,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
            profiles: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
    };
</script>
